
import {defineComponent} from 'vue';

export default defineComponent({
	name: 'DwLoader',
	props: {
		active: Boolean
	}
});
